import { Redirect, Route, Switch } from "react-router-dom";

import Heading from "@components/heading/heading";

import AiWorkspacePage from "./ai-workspace-page";

const AiSettings = () => {
  return (
    <div aria-label="AI settings">
      <Heading small title="AI" />
      <div className="mt-6">
        <Switch>
          <Route exact path="/account/ai/workspace">
            {/* AiWorkspacePage self-guards: it shows a loader while the org
                query resolves and redirects non-admins. */}
            <AiWorkspacePage />
          </Route>
          <Route exact path="/account/ai/scheduled">
            <Redirect to="/agent/routines" />
          </Route>
          <Route exact path={["/account/ai/preferences", "/account/ai/memory"]}>
            <Redirect to="/agent/preferences" />
          </Route>
          <Route>
            <Redirect to="/agent" />
          </Route>
        </Switch>
      </div>
    </div>
  );
};

export default AiSettings;
